import { MoreHorizontal, Trash2 } from "lucide-react";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface MapCardProps {
  title: string;
  imageUrl: string;
  onClick?: () => void;
  onDelete?: () => void;
}

export function MapCard({ title, imageUrl, onClick, onDelete }: MapCardProps) {
  return (
    <Card
      className="group relative cursor-pointer overflow-hidden rounded-lg shadow-sm transition-all duration-300"
      onClick={onClick}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-muted">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        {onDelete && (
          <div
            className="absolute right-2 top-2 opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100"
            onClick={(e) => e.stopPropagation()}
          >
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="secondary" size="icon" className="h-7 w-7">
                  <MoreHorizontal className="h-4 w-4" />
                  <span className="sr-only">City options</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem
                  className="text-destructive focus:text-destructive"
                  onClick={onDelete}
                >
                  <Trash2 className="mr-2 h-4 w-4" />
                  Delete city
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
      <CardContent className="p-4">
        <div className="space-y-1">
          <CardTitle className="text-lg font-medium">{title}</CardTitle>
        </div>
      </CardContent>
    </Card>
  );
}
